import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWallet = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 20,
			width: 32,
			height: 20,
			rx: 2,
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 20V14C16 10.686 19.134 8 24 8C28.866 8 32 10.686 32 14V20",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 24,
			cy: 30,
			r: 3,
			fill: "currentColor",
			opacity: .5
		})
	]
});
export default SvgWallet;
